// extracted by mini-css-extract-plugin
module.exports = {"deleteIconCSS":"VIP_StandardChipList__deleteIconCSS","deleteIconCss":"VIP_StandardChipList__deleteIconCSS"};